import { SYSTEM_MANAGED_NETWORK_PARAMS } from "constant/application";
import get from "lodash/get";
import { defaultObject } from "redux-store/selectors";

function getSystemManagedParams(network) {
  if (!isSystemManaged(network)) {
    return null;
  }

  return SYSTEM_MANAGED_NETWORK_PARAMS;
}

function isSandbox(network) {
  return network.is_sandbox;
}

function isSystemManaged(network = {}) {
  return network.system_managed || false;
}

function networksSelector(state) {
  return get(state, "global.networks.byId", defaultObject);
}

export { getSystemManagedParams, isSandbox, isSystemManaged, networksSelector };
